<template>
  <BaseGreetingWidget>
    <!-- <template #body>
        Content here is optional and may not always be included because it's not always relevant.
      </template> -->
  </BaseGreetingWidget>
</template>

<script setup lang="ts">
import { BaseGreetingWidget } from "@modernary/mui/components/widgetGrid";
</script>
